import { createStorage } from "@/script/storage/storage-factory"

export default createStorage({
	buildNumber: "b1337.04.20",
	selectedLocation: null,
	selectedMap: null,
	lastMarkerType: null,
	markedLocations: [],
	markedLocationsLocal: [],
	modalHowToContribute: false,
	modalPreferences: false,
	modalChangelog: false,
})
